/**************************************************
 * Nombre:       Casilla_Titulo_Estado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Titulo_Estado = ({estado = '', arrEstados = [], dir, titulo}) => {

    let index = arrEstados.findIndex((e) => e.nombre === estado)

    return (
        <TableCell key={estado+new Date().getTime()} variant={'body'} align={dir} sx={{color: COLORTEXTO, fontSize: 14}}>

            <Grid container size={12} alignItems={'center'}>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 12}}>
                            {titulo}
                        </Typography>
                    </Grid>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-start'}>

                        <Typography
                            sx={{
                                textAlign: 'left',
                                fontWeight: 600,
                                color: index > -1 ? arrEstados[index].color : '#5d87ff',
                                fontSize: 14,
                                px: 1,
                                backgroundColor: index > -1 ? arrEstados[index].color + 20 : '#5d87ff10', borderRadius: 1.5
                            }}>{estado}</Typography>

                    </Grid>
                </Grid>

            </Grid>



        </TableCell>

    )

}
export default Casilla_Titulo_Estado